module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ComponentForm', {
    attrs: {
      "label": _vm.trads.createHead,
      "loading": _vm.saving
    },
    on: {
      "save": _vm.save
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d952fb66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-form/create-component.vue
// module id = 3379
// module chunks = 0